import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {RFParamSetElement} from "../../models/rf-paramset-element.model";
import {NgForm} from "@angular/forms";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {UserVerificationService} from "../../services/user-verification.service";
import {Location} from "@angular/common";
import {ActivatedRoute, Router} from "@angular/router";
import {ApiEndpoints} from "../../services/api-endpoints";

@Component({ standalone: false, 
  selector: 'app-add-rfparam-set',
  templateUrl: './add-rfparam-set.component.html',
})
export class AddRfparamSetComponent implements OnInit {

  public rfParamSetElement: RFParamSetElement;
  public title;
  public virtId;
  public nsName;

  public paramSetIdExist: boolean = false;

  public class = ["ng-valid", "ng-touched", "ng-dirty"];
  public errorClass = ["ng-pristine", "ng-invalid", "ng-touched"];

  @ViewChild('validate', { static: true }) validate: NgForm;


  constructor(private router: Router,
    private route: ActivatedRoute,
    userVerificationService: UserVerificationService,
    private _location: Location,
    private http: HttpClient) {

    this.rfParamSetElement = new RFParamSetElement();
  }

  ngOnInit() {
    this.virtId = this.route.snapshot.queryParams["virtId"]
    this.nsName = this.route.snapshot.queryParams["name"];
    this.title = this.route.snapshot.queryParams["title"];
  }

  trimValue(event) {
    event.target.value = event.target.value.replace(/\s\s+/g, ' ');
  }

  validateParamSetId(paramSetId, paramSetIdElement) {
    this.paramSetIdExist = false;
    paramSetIdElement.classList.remove(...this.class);
    if(paramSetId.trim().length == 0) {
      paramSetIdElement.classList.remove(this.class);
      paramSetIdElement.classList.add(this.errorClass);
    } else {
      let headers = new HttpHeaders({'Content-Type': 'application/json'});
      let options =  {headers: headers}
      var url = ApiEndpoints.EXISTS_RF_PARAM_SET_ID;
      paramSetId = paramSetId.replace(/\s\s+/g, ' ');
      paramSetId = paramSetId.trim();
      var body = {
        "virtId": this.virtId,
        "paramSetId": paramSetId
      };
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.paramSetIdExist = data.response;
          }
        );
      if(this.paramSetIdExist) paramSetIdElement.classList.add(...this.errorClass)
      else paramSetIdElement.classList.add(...this.class);
    }
  }

  validateActilityRfParamSet(actilityRfParamSet, actilityRfParamSetElement) {
    if(actilityRfParamSet.trim().length == 0) {
      actilityRfParamSetElement.classList.remove(this.class);
      actilityRfParamSetElement.classList.add(this.errorClass);
    } else {
      actilityRfParamSetElement.classList.add(...this.class)
    }
  }

  fileChangeEvent(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      var file: any = fileInput.target.files[0];
      let reader = new FileReader();
      reader.onload = (e: any) => {
        this.rfParamSetElement.ActilityRFParamSet =  reader.result.toString();
      }
      reader.readAsText(file);
    }
  }

  addRFParamSetElement() {
    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    let options =  {headers: headers}
    var url = ApiEndpoints.ADD_RF_PARAM_SET_ELEMENT;
    var body = {
      "virtId": this.virtId,
      "psId": this.rfParamSetElement.RFParamSetID,
      "actilityPs": this.rfParamSetElement.ActilityRFParamSet
    };
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.paramSetIdExist = data.response;
        }
      );
    this._location.back();
  }

  backClicked() {
    this._location.back();
  }
}
